/**
 * A patient's contacts — family, surrogates, emergency numbers.
 *
 * Replaces `Contact.InsertContact` and the rest of the `Contact` keyon envelope,
 * plus `Account.SendContactInvitationEmail`.
 *
 * A contact is not a user. They become one only by accepting an invitation, at
 * which point pacmny-auth owns the credential and the contact row keeps holding
 * the relationship — which is why the invitation is a top-level resource here
 * rather than a flag on the contact: it outlives the request and has a state of
 * its own.
 */

import api from './client';

export function listContacts(patientId, params = {}) {
  return api.list(`/patients/${patientId}/contacts`, params);
}

export function createContact(patientId, payload) {
  return api.post(`/patients/${patientId}/contacts`, payload);
}

export function updateContact(patientId, contactId, patch) {
  return api.patch(`/patients/${patientId}/contacts/${contactId}`, patch);
}

export function deleteContact(patientId, contactId) {
  return api.delete(`/patients/${patientId}/contacts/${contactId}`);
}

/**
 * Its own sub-resource, and a PUT, because setting it clears the flag on every
 * other contact for the chart — one transaction, not a field write.
 */
export function setPrimaryContact(patientId, contactId) {
  return api.put(`/patients/${patientId}/contacts/${contactId}/primary`);
}

/**
 * Invite someone to hold a portal account for this patient. `patient_id`,
 * `first_name`, `last_name`, `email` and a `relationship` from the closed set
 * are all required: the legacy call site sent none of them and the server
 * inferred the recipient from whichever session happened to be open.
 */
export function inviteContact(payload) {
  return api.post('/contact-invitations', payload);
}

export default {
  listContacts, createContact, updateContact, deleteContact,
  setPrimaryContact, inviteContact,
};
